import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Tooltip } from "reactstrap";
import { useVisible } from "../../../../../utils/hooks/useVisible";

/**
 * The warning marker on a miss-punch row. Rendered against whichever cell holds the unknown time -
 * the IN cell when the clock-in is missing, the OUT cell when the clock-out is - so the employee or
 * manager is pointed at the field they actually have to fill in.
 */
export const MissPunchTooltip = ({ original, openMissPunchModal, isMyTimesheet, side = "end" }) => {
    const { t } = useTranslation();
    const { visible, toggle } = useVisible();
    const id = `miss-punch-${side}-${original.user.id}-row-${original.id}`;

    let message;
    switch (original.missPunchStatus) {
        case "pending":
            message = t("miss-punch-request-info")
            break;
        case "approved":
            message = t("miss-punch-request-approved")
            break;
        default: {
            if (isMyTimesheet) {
                message = side === "start"
                    ? t("click-to-request-miss-punch-adjustment-in")
                    : t("click-to-request-miss-punch-adjustment")
            } else {
                message = side === "start" ? t("is-miss-punch-in") : t("is-miss-punch")
            }
        }
    }

    return (
        <>
            <span
                id={id}
                className={
                    classNames(
                        "ml-2 font-weight-bolder text-lg",
                        isMyTimesheet && "cursor-pointer",
                        "text-orange",
                    )
                }
                onClick={
                    (isMyTimesheet && !original.missPunchStatus && openMissPunchModal)
                        ? () => openMissPunchModal(original)
                        : undefined
                }
            >
                &#9888;
            </span>

            <Tooltip target={id} isOpen={visible} toggle={toggle}>
                {message}
            </Tooltip>
        </>
    );
}

export default MissPunchTooltip;
